import React, { useState, useEffect } from 'react';
import axios from '../axios';

// Same named allowlist the server checks in /set_order_closed.
const CLOSE_JOB_ALLOWLIST = ['bithi', 'nadia', 'admin'];

// Fetched once and shared by every button on the page.
let usernamePromise = null;
const getCurrentUsername = () => {
    if (!usernamePromise) {
        usernamePromise = axios.get(`${window.backendUrl}/verify-token`, { withCredentials: true })
            .then(res => (res.data.username || '').trim().toLowerCase())
            .catch(() => { usernamePromise = null; return ''; });
    }
    return usernamePromise;
};

// Shows a "CLOSED" tag on a closed job for everyone, and a Close Job / Reopen Job button for
// the allowlisted users. A closed job leaves the pending orders list and can't get a new challan.
function CloseJobButton({ order, pendingQty, onChanged }) {
    const [username, setUsername] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        getCurrentUsername().then(setUsername);
    }, []);

    const canToggle = CLOSE_JOB_ALLOWLIST.includes(username);
    const isClosed = !!order.is_closed;

    const handleClick = () => {
        const msg = isClosed
            ? `Reopen job ${order.jobNo}? It will show in pending orders again.`
            : `Close job ${order.jobNo}?${pendingQty > 0 ? ` ${pendingQty} pcs are still undelivered.` : ''}\n\nOnly close it if payment is received and nothing more will be delivered. It will no longer show in pending orders.`;
        if (!window.confirm(msg)) return;
        setSaving(true);
        axios.post(`${window.backendUrl}/set_order_closed`, { orderId: order.orderId, close: !isClosed })
            .then(() => onChanged && onChanged())
            .catch(err => alert(err.response?.data?.error || 'Failed to update job'))
            .finally(() => setSaving(false));
    };

    const closedInfo = isClosed && order.closed_by
        ? `Closed by ${order.closed_by}${order.closed_at ? ' on ' + new Date(order.closed_at * 1000).toLocaleDateString('en-GB', { timeZone: 'Asia/Dhaka' }) : ''}`
        : undefined;

    return (
        <div style={{ marginTop: '4px' }}>
            {isClosed && (
                <span title={closedInfo} style={{ display: 'inline-block', backgroundColor: '#6c757d', color: 'white', borderRadius: '4px', padding: '1px 6px', fontSize: '11px', fontWeight: 'bold' }}>
                    CLOSED
                </span>
            )}
            {canToggle && (
                <div>
                    <button
                        type="button"
                        onClick={handleClick}
                        disabled={saving}
                        style={{ marginTop: '4px', fontSize: '11px', padding: '1px 6px', border: '1px solid', borderRadius: '4px', cursor: 'pointer',
                            backgroundColor: isClosed ? '#e7f1ff' : '#fff3f3', borderColor: isClosed ? '#0d6efd' : '#dc3545', color: isClosed ? '#0d6efd' : '#dc3545' }}
                    >
                        {saving ? '...' : isClosed ? 'Reopen Job' : 'Close Job'}
                    </button>
                </div>
            )}
        </div>
    );
}

export default CloseJobButton;
